import { DecryptedPropertyStub, UserGroup } from '@icure/cardinal-sdk'
import { APPLICATION_ID } from '../constants'

export interface UserGroupMappedType {
  id: string
  superGroup: string
  groupName: string
  properties: DecryptedPropertyStub[]
  userEmail: string
  userName: string
  userRole?: string
}

export const userGroupMapper = (userGroup: UserGroup): UserGroupMappedType => ({
  id: userGroup.groupId ?? '',
  superGroup: (userGroup.groupsHierarchy && userGroup.groupsHierarchy[1] ? userGroup.groupsHierarchy[1]?.name : userGroup.nameOfParentOfTopmostGroupInHierarchy) ?? '',
  groupName: userGroup.groupName ?? '',
  properties: userGroup.groupsHierarchy[0] ? (userGroup.groupsHierarchy[0]?.properties ?? []) : [],
  userEmail: userGroup.email ?? '',
  userName: userGroup.name ?? '',
})

/**
 * Filters user group matches to only include groups that belong to the current application.
 *
 * This function filters out UserGroup entries where the top-level group (groupsHierarchy[0])
 * doesn't match the current APPLICATION_ID. This ensures that only groups relevant to the
 * current RetinoBridge application are included, excluding groups from other applications
 * or projects that the user might have access to.
 *
 * The groupsHierarchy represents the organizational structure, where:
 * - groupsHierarchy[0] is the top-level (application/project) group
 * - groupsHierarchy[1+] are nested child groups
 *
 * @param matches - Array of UserGroup objects to filter
 * @returns Filtered array containing only groups belonging to the current application
 */
export const trimUserGroupsMatches = (matches: UserGroup[]): UserGroup[] => matches.filter((m) => m.groupsHierarchy?.[0]?.projectId === APPLICATION_ID)
